module.exports = __webpack_public_path__ + "img/7.dd782c9c.png";